export default __webpack_public_path__ + "static/media/portfolio-217.ec80f59f.jpg";